import React from 'react';
import './ContactUs.scss';

const ContactUs = () => {
  return (
    <div className="contact-us-section">
      <div className="overlay">
        <h2>Contact Us</h2>
        <div className="form-container">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSf5n2RUb8zOdVpTA5vvp6JMrIgFWaZ54O6OZ8LzM19v-eGK-w/viewform?embedded=true"
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Contact Us Form"
            allowFullScreen
          >
            Loading…
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
